/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A clarification nobody asked about: plain text, 1 to 5000 characters.
 * @export
 * @interface EventAnnouncementCreate
 */
export interface EventAnnouncementCreate {
    /**
     * 
     * @type {string}
     * @memberof EventAnnouncementCreate
     */
    answer_text: string;
}

/**
 * Check if a given object implements the EventAnnouncementCreate interface.
 */
export function instanceOfEventAnnouncementCreate(value: object): value is EventAnnouncementCreate {
    if (!('answer_text' in value) || value['answer_text'] === undefined) return false;
    return true;
}

export function EventAnnouncementCreateFromJSON(json: any): EventAnnouncementCreate {
    return EventAnnouncementCreateFromJSONTyped(json, false);
}

export function EventAnnouncementCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventAnnouncementCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'answer_text': json['answer_text'],
    };
}

export function EventAnnouncementCreateToJSON(json: any): EventAnnouncementCreate {
    return EventAnnouncementCreateToJSONTyped(json, false);
}

export function EventAnnouncementCreateToJSONTyped(value?: EventAnnouncementCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'answer_text': value['answer_text'],
    };
}

